import { Link, useParams } from "react-router-dom";
import { useSession } from "@otto/plattform";
import { useClass } from "../../classes/lib/data.js";
import { CodeGenerator } from "./CodeGenerator.js";
import { CodeTable } from "./CodeTable.js";
import { useCardsDownload } from "../hooks/useCardsDownload.js";
import { useCodes, useDeleteCode, useMakeCodes } from "../lib/data.js";
import styles from "../../../shared/components/shell.module.css";

export function ClassDetail() {
  const { classId = "" } = useParams();
  const { client } = useSession();
  const schoolClass = useClass(client, classId);
  const codes = useCodes(client, classId);
  const makeCodes = useMakeCodes(client, classId);
  const deleteCode = useDeleteCode(client, classId);
  const cards = useCardsDownload();

  return (
    <div className={styles.card}>
      <p className={styles.subtitle} style={{ marginBottom: 10 }}>
        <Link to="/classes">← Klassen</Link>
      </p>
      <h1 className={styles.title}>
        Übungscodes{" "}
        {schoolClass.data
          ? `· ${schoolClass.data.name} · ${schoolClass.data.school_year}`
          : ""}
      </h1>
      <p className={styles.subtitle}>
        Drucken Sie die Kärtchen aus und schreiben Sie den Namen des Kindes von Hand
        darauf. Diese Zuordnung bleibt bei Ihnen – auf der Plattform steht kein
        Kindername.
      </p>

      {/* Erzeugen und drucken stehen in einer Zeile: für die Lehrkraft ist das
          ein Handgriff am Schuljahresanfang und kein zweiter Vorgang. */}
      <CodeGenerator
        pending={makeCodes.isPending}
        error={
          makeCodes.isError
            ? makeCodes.error instanceof Error
              ? makeCodes.error.message
              : "Die Codes konnten nicht erzeugt werden."
            : null
        }
        onGenerate={(count) =>
          makeCodes.mutate({ count, taken: (codes.data ?? []).map((c) => c.code) })
        }
      >
        {codes.data && codes.data.length > 0 && (
          <>
            <button
              type="button"
              // Wie „Urkunde als PDF“ auf der Ergebnisseite: das Drucken ist
              // eine Hauptsache dieser Seite, keine Nebensache. In Grau sah der
              // Knopf aus, als wäre er abgeschaltet.
              className={styles.button}
              disabled={cards.printing || !schoolClass.data}
              onClick={() => {
                if (!schoolClass.data || !codes.data) return;
                void cards.download({
                  className: schoolClass.data.name,
                  schoolYear: schoolClass.data.school_year,
                  codes: codes.data.map((c) => c.code),
                });
              }}
            >
              {cards.printing ? "Wird erzeugt …" : "Kärtchen als PDF"}
            </button>
            <span className={styles.subtitle} style={{ margin: 0 }}>
              {codes.data.length} Kärtchen, 8 pro Seite
            </span>
          </>
        )}
      </CodeGenerator>

      {codes.isPending && <p className={styles.empty}>Codes werden geladen …</p>}
      {codes.data?.length === 0 && (
        <p className={styles.empty}>Noch keine Codes erzeugt.</p>
      )}
      {codes.data && codes.data.length > 0 && (
        <CodeTable codes={codes.data} onDelete={(id) => deleteCode.mutate(id)} />
      )}
    </div>
  );
}
